<template>
  <resource-search
    search-context="explore"
    :resource-props="{
      'show-user': true
    }"
    :allow-all-tags="true"
    :use-tag-text-in-url="true"
  >
    <template v-slot:header>
      <div class="flex items-center">
        <nice-icon
          icon="users"
          class="mr3 has-text-primary search-header-icon"
        ></nice-icon>
        <heading size="medium" :spacing-bottom="false">{{
          $t("nav.explore")
        }}</heading>
      </div>
    </template>

    <template v-slot:empty>
      <b-message>
        Seems like there are no public resources yet.
        <br />
        <br />Be the first to add one by clicking the button with the plus icon
        in the bottom right to
        <router-link to="/resource">add a resource</router-link> and set it to
        public. <br />
        If you copy the URL of the resource first, we will grab it from your
        clipboard and prefill the inputs.
        <br />
        <br />A browser extension for Chrome and Firefox is comming very soon.
      </b-message>
    </template>
  </resource-search>
</template>

<script>
import ResourceSearch from "@/components/resource/Search.vue";

export default {
  components: {
    ResourceSearch
  },

  watch: {
    initAndContext: {
      immediate: true,
      async handler(val) {
        if (val) {
          this.$wait.start("loading.explore");

          this.$store.commit("explore/CLEAR_TAGS");
          this.$store.commit("explore/default/SET_PAGE", 0);

          await Promise.all([
            this.$store.dispatch("explore/fetchTags"),
            this.$store.dispatch("explore/default/fetchResources")
          ]);

          this.$wait.end("loading.explore");
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
